@switch (status) {
    @case ('dataConnectionError') {
        <div
            class="d-flex flex-column align-items-center p-5"
            [attr.data-cy]="(dataTypeLabel | camelCase) + '-error'"
        >
            <wdx-icon
                icon="plug-circle-exclamation"
                iconStyle="fa-duotone"
                [scale]="3"
                class="mb-4"
            ></wdx-icon>
            <div class="d-flex align-items-center">
                <h6 class="mb-0">
                    {{ errorHeader | translateTokenisedString }}
                </h6>

                @if (connectionErrorMessage) {
                    <wdx-icon-button
                        class="ms-2"
                        size="sm"
                        wdxStyle="primary"
                        (wdxOnClick)="showHideConnectionError()"
                    >
                        <wdx-icon icon="info"></wdx-icon>
                    </wdx-icon-button>
                }
            </div>

            @if (connectionErrorMessage && showConnectionError) {
                <div
                    class="connection-error mt-2 overflow-auto"
                    [innerHTML]="connectionErrorMessage"
                ></div>
            }
        </div>
    }

    @case ('loading') {
        <div
            class="d-flex justify-content-center align-items-center h-100 p-5"
            [attr.data-cy]="(dataTypeLabel | camelCase) + '-loading'"
        >
            <wdx-spinner></wdx-spinner>
        </div>
    }

    @case ('noData') {
        <wdx-feature-svg
            size="xs"
            [attr.data-cy]="'no-' + (dataTypeLabel | camelCase)"
            label="No {{ dataTypeLabel }} data"
            class="p-5"
        >
        </wdx-feature-svg>
    }
}
